export const CalendarDefaultStyle = {
  backgroundColor: "#ABADAD",
} as const;
